_getPmSectionMultiple